import {SvgIcon, SvgIconProps} from "@mui/material";
import React, {CSSProperties, SVGProps, useState} from "react";
import {useStyle} from "../../hooks";
import {motion} from "framer-motion";

const GridIcon = (props: SVGProps<SVGSVGElement> & {on?: boolean}) => {
    let p = 1;
    let s = 14;
    let r = 4.5;
    return <svg {...props} viewBox={"-15 -15 60 60"}>
        <mask id={"grid-icon-mask"}>
            <rect x={-15} y={-15} width={"100%"} height={"100%"} fill={"#ffffff"}/>
            <motion.line
                animate={{scale: props.on ? 0 : 1, transition: {delay: props.on ? 0 : .25}}}
                x1={-5}
                y1={35}
                x2={35}
                y2={-5}
                stroke={"#000"}
                strokeWidth={12}
            />
        </mask>
        <g mask={"url(#grid-icon-mask)"} fill={props.style?.color}>
        {[0, 1, 2].map(i => {
            return [0, 1, 2].map(j => {
                if (i === 2 - j) {
                    return <motion.circle
                        animate={{scale: props.on ? 1 : 0, transition: {delay: props.on ? .25 : 0}}}
                        key={"grid icon ani c " + i + "_" + j}
                        cx={p + i * s}
                        cy={p + j * s}
                        r={r}
                    />;
                } else {
                    return <circle
                        key={"grid icon c " + i + "_" + j}
                        cx={p + i * s}
                        cy={p + j * s}
                        r={r}
                    />
                }
            })
        })}
        </g>
        <motion.line
            animate={{scale: props.on ? 0 : 1, transition: {delay: props.on ? 0 : .25}}}
            x1={-5}
            y1={35}
            x2={35}
            y2={-5}
            stroke={props.style?.color}
            strokeWidth={5}
        />
    </svg>
}

export default ({value, onChange, ...props}: {
    value: boolean,
    onChange: () => any,
    size?: number,
    style?: CSSProperties
}) => {
    const [hovered, setHovered] = useState<boolean>(false);

    const handleHover = () => setHovered(true);
    const handleUnhover = () => setHovered(false);

    const style = useStyle();

    return <div
        style={{
            cursor: 'pointer',
            opacity: hovered ? 1.0 : 0.5
        }}
        onClick={onChange}
        onMouseEnter={handleHover}
        onMouseLeave={handleUnhover}
    >
        <GridIcon
            on={!value}
            width={24}
            height={24}
            style={{
                fontSize: props.size ?? 20,
                color: style.palette.default.main
            }}
        />
    </div>
}